import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcColumnTypeModule } from '@datachain/ui-sdk/components/app-column-type';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import {
	DcHighlightDirectiveModule,
	DcNavigateDirectiveModule,
} from '@datachain/ui-sdk/directives';
import {
	DcArrayPipeModule,
	DcTruncatePipeModule,
} from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
	DxDataGridModule,
	DxSelectBoxModule,
	DxTextBoxModule,
	DxValidatorModule,
} from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { CreateEntityFromDepotModalComponent } from './components/create-entity-from-depot-modal/create-entity-from-depot-modal.component';
import { DepotActionPopupComponent } from './components/depot-action-popup/depot-action-popup.component';
import { DepotListComponent } from './components/depot-list/depot-list.component';
import { DcCoreDepotSchemaViewerModule } from './components/depot-schema-viewer/depot-schema-viewer.component';
import { AppHeaderMappingModalComponent } from './components/header-mapping-modal/header-mapping-modal.component';
import { DepotAdapter } from './depot.adapter';
import { NgDepot } from './ng-depot';
import {
	DepotEffects,
	DepotFeatureKey,
	depotReducers,
	DepotSelector,
} from './store';

@NgModule({
	declarations: [
		DepotListComponent,
		DepotActionPopupComponent,
		CreateEntityFromDepotModalComponent,
		AppHeaderMappingModalComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(DepotFeatureKey, depotReducers),
		EffectsModule.forFeature([DepotEffects]),
		DxDataGridModule,
		DxSelectBoxModule,
		DxTextBoxModule,
		DxValidatorModule,
		NgOptimizedImage,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcBadgeModule,
		DcAvatarModule,
		DcNavigateDirectiveModule,
		DcBreadcrumbModule,
		DcColumnTypeModule,
		CommonModule,
		MaterialModule,
		DcCoreDepotSchemaViewerModule,
		FormsModule,
		DcButtonModule,
		UiModule,
		DcColumnTypeModule,
		DcHighlightDirectiveModule,
		DcTruncatePipeModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
	],
	providers: [DepotAdapter, DepotSelector, NgDepot],
})
export class DepotModule {
	public constructor(private readonly injector: Injector) {
		const depotListCmpElement = createCustomElement(DepotListComponent, {
			injector,
		});
		customElements.define('app-depot-list', depotListCmpElement);
	}
}
